module.exports = __webpack_public_path__ + "img/1586465496.6320e2d2.jpg";